<template>
    <v-flex class="xs12">
        <v-select
                :items="events"
                label="Событие"
                v-model="eventModel.event"
                value="start_message"
                item-text="text"
                item-value="value"
                @change="changeMethodByEvent(eventModel.method)"
        ></v-select>
        <v-select
                v-if="methods.hasOwnProperty(eventModel.event) && methods[eventModel.event].findIndex(method => method.value === eventModel.method) !== -1"
                :items="methods[eventModel.event]"
                label="Метод"
                v-model="eventModel.method"
                item-text="text"
                item-value="value"
                @change="changeMethod(eventModel.method)"
        ></v-select>
        <v-text-field
                v-if="methods.hasOwnProperty(eventModel.event) && methods[eventModel.event].findIndex(method => method.value === eventModel.method) === -1"
                v-model="eventModel.method"
                :label="methods[eventModel.event].find(value => value.value === 'custom').text"
        ></v-text-field>
        <v-btn
                v-show="methods.hasOwnProperty(eventModel.event) && methods[eventModel.event].findIndex(method => method.value === eventModel.method) === -1"
                color="blue lighten-2"
                dark
                @click="changeMethodByEvent"
        >Выбрать из списка</v-btn>
    </v-flex>
</template>

<script>
export default {
    name: 'EventListSelect',
    props: ['eventModel'],
    data() {
        return {
            events: [
                { value: 'message_start', text: 'Первое сообщение' },
                { value: 'ref', text: 'Реферальная ссылка' },
                // { value: 'refNotReplace', text: 'Реферальная ссылка без замены реферала' },
                { value: 'message_reply', text: 'Исходящее сообщение(вк)' },
                { value: 'dialog', text: 'Событие в чате(вк)' },
                { value: 'standard', text: 'Если не сработали правила' },
                { value: 'reply_to_message', text: 'Ответ на пересланное сообщение' },
                { value: 'wall_post_new', text: 'Новый пост на стене (вк)' },
                { value: 'wall_repost', text: 'Репост (вк)' },
                { value: 'wall_reply_new', text: 'Добавление комментария на стене(вк)' },
                { value: 'wall_reply_delete', text: 'Удаление комментария на стене(вк)' },
                { value: 'poll_vote_new', text: 'Голосование в опросе' },
                { value: 'photo_attachment', text: 'Если сообщение содержит фотографию' },
                { value: 'script', text: 'Скрипт выполняется все время' },
                { value: 'contact', text: 'Клиент прикрепил свой телефон' },
                { value: 'location', text: 'Клиент отправил свое место положение' },
                { value: 'shop', text: 'Событие в магазине' }
            ],
            methods: {
                dialog: [
                    { value: 'chat_invite_user_by_link', text: 'Пользователь добавился в диалог по ссылке' },
                    { value: 'chat_invite_user', text: 'Пользователь добавился в диалог' },
                    { value: 'chat_kick_user', text: 'Пользователь вышел из диалога' },
                    { value: 'chat_kick_by_user', text: 'Пользователь исключен из диалога' }
                ],
                ref: [
                    { value: 'click_market', text: 'Ссылка из маркета' },
                    { value: 'custom', text: 'Ввести вручную' },
                    { value: 'invite', text: 'Переход по ссылке друга' },
                    { value: 'inviter', text: 'Переход по ссылке друга (с обновлением реферала)' },
                    { value: 'myself', text: 'Переход по своей пригласительной ссылке' }, // invite -> myself
                    { value: 'invited', text: 'Повторный переход по пригласительной ссылке' }, // invite -> invited
                    { value: 'old_invited', text: 'Старый неприглашенный клиент повторно прошел по пригласительной ссылке' } // invite -> old_invited
                ],
                message_reply: [
                    { value: 'admin', text: 'От администратора группы' },
                    { value: 'group', text: 'От группы администратору' }
                ],
                wall_repost: [
                    { value: null, text: 'Без дополнений' },
                    { value: 'save_result', text: 'Сохранить результат в историю о репосте' },
                    { value: 'check_repost', text: 'Проверить ' }
                ],
                wall_reply_new: [
                    { value: 'all', text: 'Действует на все посты' },
                    { value: 'custom', text: 'ID записи' }
                ],
                shop: [
                    { value: 'first_order', text: 'Первый заказ клиента' },
                    { value: 'new_order', text: 'Заказ клиента' }
                ]
            }
        }
    },
    methods: {
        changeMethod(value) {
            if (value === 'custom') { // если выбрал
                this.eventModel.method = ''
            }
        },
        changeMethodByEvent() {
            if (this.methods.hasOwnProperty(this.eventModel.event)) {
                this.eventModel.method = this.methods[this.eventModel.event][0].value
            }
        }
    }
}
</script>

<style scoped>

</style>
